import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { Section, SectionAttributes } from '../../../app/types/section';
import { PlainImageSection, imageToPicture } from '../../../app/components/plain-image/plain-image.component';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

interface TextScrollerItemSectionAttributes extends SectionAttributes {
  image: PlainImageSection;
  zoomImageOnClick: boolean;
  headline: string;
  copyText: string; // TODO: force to h4 & h5
}

type TextScrollerItemSectionEditorIds = [
  'medium',
  'zoomImageOnClick',
  'headline',
  'copyText',
];

type TextScrollerItemSection = Section<TextScrollerItemSectionAttributes, TextScrollerItemSectionEditorIds, 'text-scroller-item'>;

type TextScrollerSection = Section<
  {
    numColumns: 12;
    headline?: string;
    backgroundColor?: 'secondary-variant' | 'secondary' | 'blue';
    showLogo?: boolean;
    items: TextScrollerItemSection[];
  } & SectionAttributes,
  [
    'headline',
  ],
  'text-scroller'
>;

@Component({
    selector: 'section[app-text-scroller]',
    styleUrls: ['./text-scroller.component.scss'],
    templateUrl: './text-scroller.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        PictureComponent,
        HtmlComponent,
        FsButtonComponent,
    ],
})
export class TextScrollerComponent extends SectionComponent<TextScrollerSection> {

  protected imageToPicture = imageToPicture;
  protected squareAspectRatio = AspectRatio.Square;

}
